import ContractInvitationsPage from "./ContractInvitationsPage";

export default ContractInvitationsPage;
